import { Contract } from 'ethers';
import { ERC20_ABI } from './constants';
/**
 * Calculate minimum output amount with slippage
 */
export function calculateAmountOutMinimum(amountOut, slippageTolerance) {
    return (amountOut * BigInt(Math.floor((1 - slippageTolerance) * 10000))) / 10000n;
}
/**
 * Helper function to encode price as sqrt price for Uniswap/Pharaoh V3
 */
export function encodePriceSqrt(reserve1, reserve0) {
    const price = (reserve1 / reserve0) * 2 ** 96;
    return BigInt(Math.floor(price)).toString();
}
/**
 * Encodes a path for Uniswap/Pharaoh router
 */
export function encodePath(path, fees) {
    if (path.length !== fees.length + 1) {
        throw new Error('path/fee lengths do not match');
    }
    let encoded = '0x';
    for (let i = 0; i < fees.length; i++) {
        // encode token
        encoded += path[i].slice(2);
        // encode fee - 3 bytes as hex
        encoded += fees[i].toString(16).padStart(6, '0');
    }
    // encode final token
    encoded += path[path.length - 1].slice(2);
    return encoded;
}
/**
 * Approve tokens for a given spender address
 */
export async function approveTokens(runner, tokenAddress, spenderAddress, amount) {
    try {
        // Get signer properly handling BrowserProvider or ContractRunner
        let signer;
        // First check if we have a BrowserProvider
        if ('getSigner' in runner) {
            try {
                // Runner is a BrowserProvider, get a signer
                signer = await runner.getSigner();
            }
            catch (e) {
                console.error('Error getting signer from BrowserProvider:', e);
                throw new Error('Could not get signer from BrowserProvider');
            }
        }
        else {
            // Assume it's a Signer or something else with similar capabilities
            signer = runner;
        }
        // Create token contract instance with the signer
        const tokenContract = new Contract(tokenAddress, ERC20_ABI, signer);
        // Get the signer address safely
        let signerAddress;
        try {
            signerAddress = await signer.getAddress();
        }
        catch (e) {
            console.error('Error calling getAddress on signer:', e);
            throw new Error('Could not get address from signer');
        }
        // Check allowance
        const allowance = await tokenContract.allowance(signerAddress, spenderAddress);
        // If allowance is sufficient, return early
        if (allowance >= amount) {
            console.log(`Allowance ${allowance} is already sufficient for amount ${amount}`);
            return true;
        }
        // Approve tokens
        const tx = await tokenContract.approve(spenderAddress, amount);
        await tx.wait();
        return true;
    }
    catch (error) {
        console.error(`Error approving tokens: ${error}`);
        return false;
    }
}
